import React from 'react';
import { Users } from 'lucide-react';

export default function RestaurantListScreen() {
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Users className="text-blue-600" size={32} />
          <div>
            <h1 className="text-3xl font-bold text-gray-900">All Restaurants</h1>
            <p className="text-gray-600 mt-1">Manage and view all restaurants in the system</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="text-center py-12">
            <Users className="text-gray-400 mx-auto mb-4" size={64} />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Coming Soon</h2>
            <p className="text-gray-600 mb-6">
              The complete restaurant list with search, filters, and management tools will be implemented here.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 max-w-md mx-auto">
              <p className="text-sm text-blue-800">
                <strong>Features:</strong> Search, filter by processor, status management, 
                and detailed restaurant information.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
